import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { CONFIGURATION_KEYS, MATHLETICS_ID } from '../../helpers/constants';
import { getConfiguration } from '../../helpers/utils';

import css from './certificates.scss';

import DownloadButton from './components/download-button/download-button';
import modalActions from '../../containers/modal-container/modal-actions';
import CertificateConfirmationModal from './components/certificate-confirmation-modal/certificate-confirmation-modal';
import { useCertificatesToast } from './hooks/use-certificates-toast';
import certificatesActions from './certificates-actions';

const Certificates = (props) => {
    const dispatch = useDispatch();
    const { renderedToast, onOpenToast } = useCertificatesToast();
    const {
        certificates,
        config,
        heading,
        isOldCertificates,
        handleCertificateDownloadClick,
        startDate,
        endDate,
        classroomId,
        groupId,
        yearGroupEnum,
        teacherUserProfileId,
        userProfileId
    } = props;
    const handleDownloadClick = ({
        certificateType,
        fullColor = true,
        certificatesCount,
        certificateTypeName,
        gemTypes = []
    }) => {
        const requestPayload = {
            startDate: moment(startDate).format('DD-MM-YYYY'),
            endDate: moment(endDate).format('DD-MM-YYYY'),
            classroomId,
            groupId,
            type: certificateType,
            certificateTypeName,
            certificatesCount,
            productId: MATHLETICS_ID,
            ...(!isOldCertificates && { gemTypes, fullColor }),
            ...(yearGroupEnum !== null && !!yearGroupEnum && { yearGroupEnum }),
            ...(teacherUserProfileId && { teacherUserProfileId }) // yearGroupEnum = 0 is a valid value for kindergarten
        };
        handleCertificateDownloadClick(requestPayload);
    };
    const showCertificatesDownloadConfirmationModal = (
        certificatesCount,
        certificateType,
        title
    ) => {
        dispatch(
            modalActions.openModal({
                content: (
                    <CertificateConfirmationModal
                        certificatesCount={certificatesCount}
                        certificateType={certificateType}
                        handleDownloadClick={({
                            fullColor,
                            gemTypes,
                            gemCount
                        }) => {
                            handleDownloadClick({
                                certificateType,
                                fullColor,
                                certificatesCount: gemCount,
                                certificateTypeName: title,
                                gemTypes
                            });
                        }}
                        {...props}
                    />
                ),
                buttons: []
            })
        );
    };
    const onClickHandler = async ({ id, type, title }) => {
        const maxCertificatesCanDownload =
            (await getConfiguration(
                CONFIGURATION_KEYS.MAX_CERTIFICATES_CAN_DOWNLOAD
            )) || 200;

        if (certificates[id] > maxCertificatesCanDownload) {
            onOpenToast();
        } else if (!isOldCertificates) {
            const requestPayload = {
                type,
                startDate: moment(startDate).format('DD-MM-YYYY'),
                endDate: moment(endDate).format('DD-MM-YYYY'),
                classroomId,
                groupId,
                studentUserProfileId: userProfileId,
                yearGroupEnum,
                teacherUserProfileId
            };
            dispatch(
                certificatesActions.getGemCountsByType(requestPayload)
            ).then(() => {
                showCertificatesDownloadConfirmationModal(
                    certificates[id],
                    type,
                    title
                );
            });
        } else {
            // download old certificates without showing modal
            handleDownloadClick({
                certificateType: type,
                certificatesCount: certificates[id],
                certificateTypeName: title
            });
        }
    };

    return (
        <div>
            {renderedToast}
            <div className={css.certificates}>
                <div className={css.certificatesContainer}>
                    <div className={css.heading}>{heading}</div>
                    <div className={css.container}>
                        {config.map(({ id, icon, title, type }) => {
                            const isDisabled =
                                certificates === null || certificates[id] === 0;
                            return (
                                <div
                                    className={`${css.certificate} ${
                                        isDisabled ? css.disabled : ''
                                    }`}
                                    key={id}
                                >
                                    <img
                                        width={'64px'}
                                        height={'40px'}
                                        src={icon}
                                        alt={title}
                                    />
                                    <div className={css.title}>{title}</div>
                                    <DownloadButton
                                        onClick={() =>
                                            onClickHandler({
                                                id,
                                                type,
                                                title
                                            })
                                        }
                                        disabled={isDisabled}
                                        title={certificates && certificates[id]}
                                    />
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

Certificates.propTypes = {
    heading: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    classroomId: PropTypes.number,
    groupId: PropTypes.number,
    userProfileId: PropTypes.number,
    certificates:
        PropTypes.shape({
            bronze: PropTypes.number,
            silver: PropTypes.number,
            gold: PropTypes.number,
            platinum: PropTypes.number,
            emerald: PropTypes.number,
            diamond: PropTypes.number,
            epic: PropTypes.number,
            legend: PropTypes.number
        }) || null,
    config: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            title: PropTypes.string,
            icon: PropTypes.string
        })
    ),
    handleCertificateDownloadClick: PropTypes.func,
    yearGroupEnum: PropTypes.number,
    teacherUserProfileId: PropTypes.number,
    isOldCertificates: PropTypes.bool
};

Certificates.defaultProps = {
    certificates: {
        bronze: 0,
        silver: 0,
        gold: 0,
        platinum: 0,
        emerald: 0,
        diamond: 0,
        epic: 0,
        legend: 0
    },
    newCertificatesConfig: []
};

export default styleable(css)(Certificates);



// WEBPACK FOOTER //
// ./components/certificates/certificates.js